<template>
  <div class="p-4">
    <h2>{{ $t('invoices.edit.edit') }}: {{ invoiceStore.invoiceNumber }}</h2>
    <div class="row">
      <InvoiceForm :key="formVersion" :submit-handler="updateInvoice">
        <template #before-headline="{ dirty, isSubmitting, invoice }">
          <ClosingInvoiceConversion class="mt-2" :invoice="invoice" :disabled="dirty || isSubmitting" @converted="converted" />
        </template>
        <template #actions="{ handleSubmit, dirty, isSubmitting }">
          <div class="d-flex flex-wrap gap-3">
            <button class="btn btn-primary"
                    type="button"
                    :aria-pressed="showPreview"
                    :disabled="isSubmitting"
                    @click="showPreview = !showPreview">
              <i class="fa-fw fa-solid" :class="showPreview ? 'fa-eye' : 'fa-eye-slash'"></i>
              {{ $t('invoices.preview') }}
            </button>

            <button class="btn btn-primary" type="submit" :disabled="isSubmitting">
              {{ $t('save') }}
            </button>

            <button class="btn btn-success"
                    type="button"
                    :disabled="isSubmitting"
                    @click="handleSubmit($event, updateInvoiceAndProceed)">
              {{ $t('invoices.save_and_proceed') }}
            </button>

            <button class="btn btn-outline-secondary"
                    type="button"
                    :disabled="isSubmitting"
                    @click="proceedWithoutSaving(dirty)">
              {{ $t('invoices.proceed_without_saving') }}
            </button>
          </div>
        </template>
      </InvoiceForm>
      <div class="col-12 col-lg-6" v-if="showPreview">
        <InvoicePreview :id="invoiceId" :version="invoiceStore.invoiceVersion"/>
      </div>
    </div>
  </div>
</template>

<script>
import {useClientStore} from "@/stores/client";
import {useInvoiceStore} from "@/stores/invoice";
import InvoicePreview from "./components/InvoicePreview.vue";
import InvoiceForm from "./components/Form.vue";
import ClosingInvoiceConversion from "./components/ClosingInvoiceConversion.vue";
import {Helpers} from "@/helpers";
import {useSetupStore} from "@/stores/setup";
import {ROUTES} from "@/scripts/constants";

export default {
  name: 'InvoicesEdit',
  components: {
    InvoiceForm,
    ClosingInvoiceConversion,
    InvoicePreview,
  },
  setup() {
    return {
      clientStore: useClientStore(),
      invoiceStore: useInvoiceStore(),
      setupStore: useSetupStore(),
    }
  },
  data() {
    return {
      showPreview: true,
      formVersion: 0,
    }
  },
  created() {
  },
  computed: {
    invoiceId() {
      return Number(this.$route.params.id);
    },
    dunningRoute() {
      return {
        name: ROUTES.DUNNING.EDIT,
        params: {invoice_id: this.invoiceId},
      }
    },
  },
  mounted() {
  },
  methods: {
    converted() {
      this.formVersion++
      this.invoiceStore.invoiceVersion++
      Helpers.emitter.emit('success', this.$t('invoices.closing.success'))
    },
    updateInvoice(values, actions) {
      return this.saveInvoice(values, actions)
    },
    updateInvoiceAndProceed(values, actions) {
      return this.saveInvoice(values, actions, true)
    },
    saveInvoice(values, actions, proceed = false) {
      return this.invoiceStore.update(values.invoice, this.invoiceId).then(() => {
        actions.resetForm({values})
        Helpers.emitter.emit('success', this.$t('invoices.edit.success'))
        this.invoiceStore.invoiceVersion++
        if (values.invoice.closing_invoice_data) this.formVersion++
        if (proceed) {
          return this.$router.push(this.dunningRoute)
        }
      })
    },
    proceedWithoutSaving(dirty) {
      if (dirty && !window.confirm(this.$t('invoices.proceed_without_saving_confirm'))) {
        return
      }
      return this.$router.push(this.dunningRoute)
    },
  },
}
</script>
